import React from 'react';
import { DialogTitle as MuiDialogTitle, IconButton, Box, styled } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface DialogTitleProps {
  children: React.ReactNode;
  onClose?: () => void;
  showIcon?: boolean;
  icon?: React.ReactNode;
}

/**
 * Styled DialogTitle component for consistent dialog headers across the application
 */
export const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 24px',
  fontSize: '18px',
  fontWeight: 600,
  fontFamily: 'Open Sans',
}));

/**
 * Shared DialogTitle component with optional close button
 */
const DialogTitle: React.FC<DialogTitleProps> = ({ 
  children, 
  onClose,
  showIcon = false,
  icon
}) => {
  return (
    <StyledDialogTitle>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {showIcon && icon}
        {children}
      </Box>
      {onClose && (
        <IconButton
          onClick={onClose}
          sx={{
            color: theme => theme.palette.text.primary,
            '&:hover': {
              backgroundColor: theme => theme.palette.action.hover
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </StyledDialogTitle>
  );
};

export default DialogTitle;